'use strict';

import template from './join.html';

var LOCAL_STORAGE_KEY = 'joinOption';

const controller = [
  '$window',
  'social',
  'vk',
  'localStorage',

  function ($window, social, vk, localStorage) {
    this.setJoinOption = function (option) {
      switch (option) {
      case 'email':
        this.isJoinFormVisible = true;
        break;

      case 'vk':
        $window.location = vk.getAuthUrl();
        break;

      default:
        this.connectWithSocial(option);
        break;
      }
    };

    this.connectWithSocial = function (socialNetworkName) {
      this.isLoading = true;

      social.login(socialNetworkName)
        .then((result) => {
          this.onSuccess({
            result: result
          });
        })
        .catch(() => {
          delete this.isLoading;
        });
    };

    this.isSocial = () => {
      return localStorage.get(LOCAL_STORAGE_KEY) === 'vk'
        || localStorage.get(LOCAL_STORAGE_KEY) === 'fb';
    };
  }
];
const saJoin = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        onSuccess: '&',
        userType: '@',
        newDesign: '@'
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saJoin;



// WEBPACK FOOTER //
// ./app/src/modules/join/join.component.js